import axios, { AxiosResponse, AxiosError } from 'axios';
import { ApiResponse, LoginResponse, User } from '../types/api';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true // Cookie ile oturum için
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Her istekte credentials'ı ekle
    config.withCredentials = true;
    
    // Token varsa Authorization header'a ekle
    const token = document.cookie
      .split('; ')
      .find(row => row.startsWith('token='))
      ?.split('=')[1];
      
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => {
    // Error response detaylarını logla
    console.error('Response error:', {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message
    });
    
    // 401 hatalarında otomatik login sayfasına yönlendirme yapma
    // Çünkü verify fonksiyonu 401 alabilir ve bu normal
    
    return Promise.reject(error);
  }
);

// API fonksiyonları
export const authApi = {
  login: async (credentials: { username: string; password: string }): Promise<LoginResponse> => {
    try {
      const response = await api.post<ApiResponse<{ user: User }>>('/auth/login', credentials);
      
      if (!response.data.data?.user) {
        throw new Error('Kullanıcı bilgileri alınamadı');
      }
      
      return {
        success: true,
        data: {
          user: response.data.data.user
        }
      };
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  },
  
  verify: async (): Promise<ApiResponse<{ user: User }> | null> => {
    try {
      const response = await api.get<ApiResponse<{ user: User }>>('/auth/verify');
      return response.data;
    } catch (error: any) {
      // 401 hatası normal (kullanıcı login değil)
      if (error.response?.status === 401) {
        console.log('Token yok veya geçersiz - kullanıcı login değil');
        return null;
      }
      
      // Diğer hatalar için logla
      console.error('Verify error:', {
        status: error.response?.status,
        message: error.response?.data?.error || error.message
      });
      
      return null;
    }
  }
};

export default api; 